/**
 * @fileoverview Module for `src/admin/tables/AddressColumn.js`.
 */

/**
 * Table cell renderer for user mailing addresses.
 *
 * @param {Object} record
 * @returns {JSX.Element} Address lines for admin tables.
 */
const AddressColumn = (record) => (
  <div>
    <p className='MuiTypography-root MuiTypography-body2'>{ record.preferredName }</p>
    <p className='MuiTypography-root MuiTypography-body2'>{ record.address }</p>
    <p className='MuiTypography-root MuiTypography-body2'>{ record.city }, { record.state } { record.zipCode }</p>
  </div>
);

export default AddressColumn;
